import { TDispatch } from '../type';
import { TSuggestedTruckers } from './suggestedTruckers.type';

export const SuggestedTruckersReducer = (
  state: TSuggestedTruckers,
  { type, payload }: TDispatch
): TSuggestedTruckers => {
  switch (type) {
    case 'suggested_truckers_page_load':
      return {
        ...state,
        isFetchingPageSuggested: true,
        isFetchedPageSuggested: false,
      };
    case 'suggested_truckers_page_load_success':
      return {
        ...state,
        isFetchingPageSuggested: false,
        isFetchedPageSuggested: true,
        dataSuggested: [...state.dataSuggested, ...(payload as TSuggestedTruckers['dataSuggested'])],
        errorSuggested: null,
      };
    case 'suggested_truckers_load':
      return {
        ...state,
        isFetchingSuggested: true,
        isFetchedSuggested: false,
        dataSuggested: null,
        errorSuggested: null,
      };
    case 'suggested_truckers_load_success':
      return {
        ...state,
        isFetchingSuggested: false,
        isFetchedSuggested: true,
        dataSuggested: payload as TSuggestedTruckers['dataSuggested'],
        errorSuggested: null,
      };
    case 'suggested_truckers_load_error':
      return {
        ...state,
        isFetchingSuggested: false,
        isFetchedSuggested: true,
        dataSuggested: null,
        errorSuggested: payload as TSuggestedTruckers['errorSuggested'],
      };
    case 'suggested_truckers_set_shared':
      return {
        ...state,
        dataSuggested: payload as TSuggestedTruckers['dataSuggested'],
      };
    default:
      return state;
  }
};

SuggestedTruckersReducer.key = 'suggestedTruckers';
SuggestedTruckersReducer.initialState = {
  isFetchingSuggested: false,
  isFetchedSuggested: false,
  dataSuggested: null,
  errorSuggested: null,
  isFetchedPageSuggested: false,
  isFetchingPageSuggested: false,
};

export default { SuggestedTruckersReducer };
